import SelfRecoveryPopUp from "../Self Recovery/SelfRecovery";

export const security_tips = [
  "Do not open phishing email",
  "Be aware of scammers",
  "Zero Trust is a Must",
];
export const generic_tips1 = [
  {
    id: "generic_1",
    text: "Not sure how to start? @Read our Estate Planing tips and recommendations@ to take into account.",
    url: "/Help-Center/estate-planning",
  },
  {
    id: "generic_2",
    text: 'Interested in understanding how OSTREON Inheritance operates? Check out our @"How It Works" guide here@.',
    url: "/how-it-works",
  },
  {
    id: "generic_3",
    text: "If one or more of your beneficiaries are minors, select a guardian for them and designate him/her as the beneficiary on their behalf. Also, provide the guardian with guidance regarding the purpose and your wishes for the minor beneficiary. If you are married with minor children, it's recommended to put you partner as priority 1 beneficiary, and your children’s guardian (different from your partner) as priority 2 beneficiary. @Click here to read more@.",
    url: "/Help-Center/estate-planning",
  },
  {
    id: "generic_4",
    text: "Think about adding your password manager login details as an asset for your beneficiaries. This action can eliminate the need to update your OSTREON Inheritance assets every time passwords are changed. @Click here@ to see some privacy aspects of this asset type.",
    url: "/Help-Center",
  },
  {
    id: "generic_5",
    text: "Have you drafted a will? @Upload the finalized and signed version as an asset!@ This ensures your beneficiary receives a scanned copy of the original document, enabling them to honor your final wishes.",
    url: undefined,
    openModal: "AddAsset",
  },
  {
    id: "generic_6",
    text: "Provide your beneficiaries guidance on using that specific 2FA for a specific asset. You can upload information about every type of 2FA: rather it's authenticator credentials/secret codes, login details for your email inbox for 2FA OTP codes, the hash or secret code for a physical key, and so forth. @Click here to learn more@.",
    url: "help-center/Backup-your-2FA",
  },
  {
    id: "generic_7",
    text: "For cases where your priority 1 beneficiaries cannot access their designated beneficiary space should something happen to you, you might want to consider transferring all their assets to priority 2 as well. @Click here to read more@ about planning for multi-priority level beneficiaries.",
    url: "/Help-Center/estate-planning",
  },
];
export const tailored_tips1 = [
  {
    id: "tailored_1",
    text: "Consider @adding your Notary or Lawyer's contact details to your inheritance tree@, ensuring your beneficiaries can reach out to them when time comes.",
    url: undefined,
    openModal: "AddNotaryPopUp",
  },
  {
    id: "tailored_2",
    text: "Consider using the “self-recovery” option in case you forget your password. Since OSTREON Inheritance operates on a zero-trust/zero-knowledge basis to secure your private data, we cannot assist you in recovering your password if it's forgotten. The “self-recovery” option is an automated process that sends you an email with specific instructions to follow. This will help you regain access and prevent your inheritance tree from being activated while you're still alive. @Click here to add a self-recovery option@.",
    url: undefined,
    action: undefined,
    openModal: "SelfRecoveryPopUp",
  },
  {
    id: "tailored_3",
    text: "Emails as 2FA are a good security practice, but it's better to secure your OSTREON Inheritance access with Authenticator app or physical key. Go to @My Account@ to activate those options.",
    url: undefined,
    navigate: "/user/account",
  },
  {
    id: "tailored_4",
    text: "Claim your 3 months for free bonus by @subscribing@ to one of our plans now",
    navigate: "/user/plan",
  },
];

export const generic_tips = [
  {
    id: "generic_1",
    text: "Not sure how to start? @Read our Estate Planing tips and recommendations@ to take into account.",
    url: "https://ostreon.io/user_lang/blog/estate-planning.html",
  },
  {
    id: "generic_2",
    text: 'Interested in understanding how OSTREON Inheritance operates? Check out our @"How It Works" guide here@.',
    url: "https://ostreon.io/user_lang/blog/how-it-works.html",
  },
  {
    id: "generic_5",
    text: "Have you drafted a will? @Upload the finalized and signed version as an asset!@ This ensures your beneficiary receives a scanned copy of the original document, enabling them to honor your final wishes.",
    url: undefined,
    openModal: "AddAsset",
  },
];

export const tailored_tips = [
  {
    id: "tailored_1",
    text: "Consider @adding your Notary or Lawyer's contact details to your inheritance tree@, ensuring your beneficiaries can reach out to them when time comes.",
    url: undefined,
    openModal: "AddNotaryPopUp",
  },
  {
    id: "tailored_3",
    text: "Emails as 2FA are a good security practice, but it's better to secure your OSTREON Inheritance access with Authenticator app or physical key. Go to @My Account@ to activate those options.",
    url: undefined,
    navigate: "/user/account",
  },
  {
    id: "tailored_4",
    text: "Claim your 3 months for free bonus by @subscribing@ to one of our plans now",
    navigate: "/user/plan",
  },
];
